import privateApiClient from "../../services/privateApiClient";
import publicApiClient from "../../services/publicApiClient";


const axiosBaseQuery =
    () =>
    async ({ url, method = "GET", data, params, headers }, _api, extraOptions) => {
        const client = extraOptions?.private ? privateApiClient : publicApiClient;
        
        try {
            const result = await client({ url, method, data, params, headers });
            return { data: result.data };
        } catch (axiosError) {
            const err = axiosError;
            return {
                error: {
                    status: err.response?.status || 500,
                    data: err.response?.data || err.message,
                },
            };
        }
    };

export default axiosBaseQuery;